import { Action } from '@ngrx/store';
import { ActionOptionsArgs, SynchronisableAction } from '../../../core/store/actions/base-actions';
import { Control } from '../control/control.model';
import { Group } from '../group/group.model';
import { Form } from './form.model';

const ENTITY = 'form';
export const REHYDRATE = '[Form] Rehydrate';
export const REMOVE = '[Form] Remove';
export const SUBMIT = '[Form] Submit';
export const UPDATE_FROM_API = '[Form] Update From API';

export class SubmitAction extends SynchronisableAction {
    readonly entity = ENTITY;
    readonly type = SUBMIT;

    constructor(public payload: Form, options?: ActionOptionsArgs) {
        super(payload, options);
    }

    getKey(): string {
        return `${this.entity}:entity:${this.payload.id}`;
    }
}

export class RehydrateAction implements Action {
    readonly entity = ENTITY;
    readonly type = REHYDRATE;

    constructor(public payload: Array<Form>) {

    }
}

export class RemoveAction extends SynchronisableAction {
    readonly entity = ENTITY;
    readonly type = REMOVE;

    constructor(public payload: Form, options?: ActionOptionsArgs) {
        super(payload, options);
    }

    getKey(): string {
        return `${this.entity}:entity:${this.payload.id}`;
    }
}

export class UpdateFromApi implements Action {
    readonly type = UPDATE_FROM_API;

    constructor(public payload: {
        control: Array<Control>,
        form: Array<Form>,
        group: Array<Group>
    }) {
    }
}

export type Actions
    = SubmitAction
    | RehydrateAction
    | RemoveAction
    | UpdateFromApi;



// WEBPACK FOOTER //
// ./src/vas/business-objects/form/form.actions.ts